import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class MoveWarehouseProvider extends HttpRequest {
  paginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-movement', query)
  }
}

export default MoveWarehouseProvider
